<template>
  <path
    d="M20 2.00024H4C2.9 2.00024 2.01 2.90024 2.01 4.00024L2 22.0002L6 18.0002H20C21.1 18.0002 22 17.1002 22 16.0002V4.00024C22 2.90024 21.1 2.00024 20 2.00024ZM16.38 12.7002L14 10.8002V13.0002C14 13.5502 13.55 14.0002 13 14.0002H7C6.45 14.0002 6 13.5502 6 13.0002V7.00024C6 6.45024 6.45 6.00024 7 6.00024H13C13.55 6.00024 14 6.45024 14 7.00024V9.20024L16.38 7.30024C17.03 6.78024 18 7.24024 18 8.08024V11.9202C18 12.7602 17.03 13.2202 16.38 12.7002Z"
  />
</template>
